import React from 'react'
import { Loader } from 'semantic-ui-react'
import { translate } from 'react-switch-lang'

const LoadingInline = ({ t }) => <div className="module loadingInline">
    <Loader active inline='centered' size='large' >{t("share.loading")}</Loader>
</div>

export default translate(LoadingInline)


// WEBPACK FOOTER //
// ./src/app/components/features/share/loadingInline.js